import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {select, Store} from '@ngrx/store';
import * as fromLayout from '../../../reducers';
import {I18nDictionaryComponent} from '../../../shared/components/i18n-dictionary/i18n-dictionary.component';
import {TitleService} from '../../../shared/services/title.service';
import * as AuthActions from '../../actions/user.actions';
import {Authenticate} from '../../models/user';
import * as fromResetPage from '../../reducers';
import '../../../shared/components/navigable';
import {GalleryItem, ImageItem} from "ng-gallery";

@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit, AfterViewInit, Navigable {
    static readonly COMPONENT_ID = 'LoginPageComponent';

    readonly titleTextId = 'login-page_title';

    isPending$;
    authError$;
    isSiteMenuOpen$;

    @ViewChild(I18nDictionaryComponent, {static: true})
    i18nDictionary: I18nDictionaryComponent;

    previewImages: GalleryItem[];
    constructor(private store: Store<fromResetPage.State>, private titleService: TitleService) {
    }

    ngOnInit(): void {
        this.isPending$ = this.store.pipe(select(fromResetPage.getAuthIsPending));
        this.authError$ = this.store.pipe(select(fromResetPage.getLoginAuthError));
        this.isSiteMenuOpen$ = this.store.pipe(select(fromLayout.getIsSiteMenuOpen));

        this.previewImages = [
            new ImageItem({ src: './assets/images/login/HB_B2B_Login_1.jpg' }),
            new ImageItem({ src: './assets/images/login/HB_B2B_Login_2.jpg' }),
            new ImageItem({ src: './assets/images/login/HB_B2B_Login_3.jpg' })
        ];
    }

    ngAfterViewInit(): void {
        this.titleService.setTitle(this.i18nDictionary.get(this.titleTextId));
    }

    onLogin(userForm: Authenticate) {
        this.store.dispatch(AuthActions.login(userForm));
    }

    getId(): string {
        return LoginPageComponent.COMPONENT_ID;
    }
}
